import { render } from "./CartBody.vue?vue&type=template&id=27c062dc&scoped=true"
import script from "./CartBody.vue?vue&type=script&lang=js"
export * from "./CartBody.vue?vue&type=script&lang=js"

import "./CartBody.vue?vue&type=style&index=0&id=27c062dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27c062dc"

export default script